export const PRESETS = {
  FocusOutline: 'focus:outline-1 focus:outline-offset-2 focus:outline-on-surface/70',
  InputField: 'rounded-2xl bg-surface-container-highest text-on-surface-container-highest',
} as const;
